class _SubviewRemover
  constructor: ->
    @viewsToBeRemoved = []

  enqueue: (subviews) ->
    for view in subviews
      view.$el.detach()
      @viewsToBeRemoved.push(view)

  processQueue: ->
    startTime = Date.now()
    count = 0
    while Date.now() - startTime < 10 && @viewsToBeRemoved.length > 0
      view = @viewsToBeRemoved.shift()
      view.remove()
      count++

module.exports = SubviewRemover = new _SubviewRemover()

setInterval ->
  SubviewRemover.processQueue()
, 10




// WEBPACK FOOTER //
// ./app/scripts/views/internal/subview-remover.coffee